import { ArrowUUpLeftIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Undo = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <ArrowUUpLeftIcon size={Sizes[size]} color={fill} {...rest} />;
};

Undo.displayName = 'Undo';
